import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalvarsService } from 'src/app/services/globalvars.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.css']
})
export class AddDeviceComponent implements OnInit {

  public pageId = 0;

  deviceid = ''
  description = ''
  department_id = 0;
  public departments: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private rest: RestService,
    private globalvar: GlobalvarsService,
    private router: Router
  ) { }

  ngOnInit(): void {
    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    this.rest.getDepartments(tmpToken.accessToken)
    .then(value => {
      this.departments.push(value)
    })
    .catch(err => {
      this.globalvar.storeToken('');
      this.router.navigateByUrl('/logon');
    })
  }

  save() {
    if (this.department_id == 0) {
      return
    }
    if(this.deviceid.length != 17 ) {
      return
    }

    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    let device = {
      id : this.deviceid,
      description : this.description,
      department_id : this.department_id
    }

    this.rest.postDevice(tmpToken.accessToken, device)
      .then(value => {
        this.router.navigateByUrl('/devices');
      })
      .catch(err => {
        this.globalvar.storeToken('');
        this.router.navigateByUrl('/logon');
      })
  }

}
